import { Reveal } from "@/components/site/motion";
import { BrainCircuit, Route, BarChart3, Cpu, Headset } from "lucide-react";

const FEATURES = [
  { icon: BrainCircuit, title: "AI Opportunity Matching", body: "Automatically recommend suitable education providers and courses based on your profile." },
  { icon: Route, title: "One Streamlined Journey", body: "One profile. One document upload. One simplified admissions process." },
  { icon: BarChart3, title: "Track Your Progress", body: "Monitor every stage of your application from enquiry through to enrolment." },
  { icon: Cpu, title: "Automation First", body: "We automate repetitive admissions tasks to reduce administration and delays." },
  { icon: Headset, title: "Human Support", body: "Get help whenever you need it from our dedicated support team." },
];

export const Features = () => (
  <section id="features" data-testid="features-section" className="relative pb-24 sm:pb-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="rounded-[28px] border border-slate-200 bg-white p-6 sm:p-10 shadow-[0_10px_40px_rgba(10,37,64,0.04)]">
        <div className="grid gap-y-10 sm:grid-cols-2 lg:grid-cols-5 lg:divide-x lg:divide-slate-100">
          {FEATURES.map((f, i) => (
            <Reveal
              key={i}
              delay={i * 0.07}
              className="lg:px-6 first:lg:pl-0 last:lg:pr-0"
              data-testid={`feature-card-${i}`}
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-cobalt/10">
                <f.icon className="h-5 w-5 text-cobalt" strokeWidth={1.75} />
              </div>
              <h3 className="mt-5 font-display text-lg font-bold tracking-tight text-ink leading-tight">{f.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slatey">{f.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
